var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { sm12: "", md12: "" } },
    [
      _c("h2", { staticClass: "h2_title mb-1" }, [
        _vm._v("\n    Asignación de números de serie\n  ")
      ]),
      _c("v-divider"),
      _c(
        "v-flex",
        {
          attrs: {
            xs12: "",
            sm12: "",
            md12: "",
            "mt-5": "",
            layout: "",
            wrap: ""
          }
        },
        [
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  !_vm.ver_resumen
                    ? _c(
                        "v-layout",
                        {
                          key: _vm.ver_resumen,
                          staticStyle: { "padding-right": "10px" },
                          attrs: {
                            row: "",
                            wrap: "",
                            "justify-space-between": "",
                            "mt-4": "",
                            "mb-5": ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.lista_series,
                                  "item-text": "nro_producto",
                                  "item-value": "nro_producto",
                                  label: "Selecciona un producto"
                                },
                                model: {
                                  value: _vm.selectedItem,
                                  callback: function($$v) {
                                    _vm.selectedItem = $$v
                                  },
                                  expression: "selectedItem"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.series,
                                  "item-text": "value",
                                  "item-value": "key",
                                  label: "Selecciona una serie"
                                },
                                model: {
                                  value: _vm.selectedSerie,
                                  callback: function($$v) {
                                    _vm.selectedSerie = $$v
                                  },
                                  expression: "selectedSerie"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticStyle: { "text-align": "end" },
                              attrs: { xs12: "", sm6: "", md4: "" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-grabar white--text",
                                  on: { click: _vm.agregar }
                                },
                                [_vm._v("Agregar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.gridOptions && _vm.columnDefs && !_vm.ver_resumen
                    ? _c(
                        "v-flex",
                        { key: _vm.ver_resumen, attrs: { sm12: "", md12: "" } },
                        [
                          _c("GridComponent", {
                            staticClass: "ag-theme-material",
                            attrs: { "grid-options": _vm.gridOptions }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.gridOptionsResp && _vm.columnDefsResp && _vm.ver_resumen
                    ? _c(
                        "v-flex",
                        { key: _vm.ver_resumen, attrs: { sm12: "", md12: "" } },
                        [
                          _c("GridComponent", {
                            staticClass: "ag-theme-material",
                            attrs: { "grid-options": _vm.gridOptionsResp }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", md12: "" } },
                    [
                      !_vm.ver_resumen
                        ? _c(
                            "v-flex",
                            {
                              key: _vm.ver_resumen,
                              staticStyle: { "text-align": "end" },
                              attrs: { xs4: "", sm12: "", md12: "" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-volver white--text",
                                  on: { click: _vm.handleCancel }
                                },
                                [_vm._v("Cancelar")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-grabar white--text",
                                  on: { click: _vm.handleGenerateAttention }
                                },
                                [_vm._v("Confirmar")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.ver_resumen
                        ? _c(
                            "v-flex",
                            {
                              key: _vm.ver_resumen,
                              staticStyle: { "text-align": "end" },
                              attrs: { xs4: "", sm12: "", md12: "" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-volver white--text",
                                  on: { click: _vm.handleCancel }
                                },
                                [_vm._v("Volver")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogPopUp,
          titulo: _vm.contextPopUp.title,
          mensaje: _vm.contextPopUp.msg,
          textoBtnSi: _vm.$t(_vm.contextPopUp.btnConfirmation),
          textoBtnNo: _vm.$t("Cancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.guardar($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }